module.exports = __webpack_public_path__ + "img/article51.df715cf5.jpg";